import domainsConfig from '@assets/cfg/domains.json';

import { default as pkg } from '@env/../package.json';
import { IEnvironment } from '@env/environment.interface';

import { HostDomain } from '../app/core/models/host-domain';

const FACEBOOK_DEFAULT_APP_ID = '1098434490199868';

export const environment: IEnvironment = {
  production: true,
  isStage: false,
  appId: 'fbs-cabinet-global',
  rootDomain: 'fbs.com',
  rootEuDomain: 'fbs.eu',
  secretKey: 'prod-djmf038vasdfwf@s0fr',
  version: pkg.version,
  defaultLanguage: 'en-US',
  defaultLocation: 'THA',
  redirectURLAfterLogin: '/dashboard',
  partnerCookieExpire: 30, // days
  cpaNetworksCookieExpire: 30, // days
  socketHost: {},
  serverUrl: {
    // fallback: 'https://ipasbf.com'
  },
  configsHost: {},
  apiData: {
    clientID: 1,
    clientSecret: '7E4erwFa9d85cTf17895CA11ABe78eUI',
    stateString: 'ssdfr3f',
  },
  gtm: {
    enable: true,
    trackingId: 'GTM-WDFWBJJ',
    domain: 'ipamtguesbf.com',
  },
  hotjar: {
    enable: false,
    trackingId: '673644',
    version: '6',
  },
  bloomreach: {
    enable: true,
    target: 'https://api-fbs.us.exponea.com',
    token: 'fb9a7f2e-5a8b-11ed-9e63-7abfce8ea968',
  },
  referral: [
    {
      name: 'admitad',
      uid: 'admitad_uid',
    },
    {
      name: 'adsterra',
      uid: 'subid',
    },
    {
      name: 'matomy',
      uid: 'cid',
    },
    {
      name: 'peerfly',
      uid: 'click_id',
    },
    {
      name: 'clickdealer',
      uid: 'sub1',
    },
    {
      name: 'toro',
      uid: 'utm_transaction_id',
    },
    {
      name: 'interspace',
      uid: 'sub_id1',
    },
  ],
  domainLanguages: [
    {
      domains: ['fbs.com'],
      language: 'en-US',
    },
  ],
  social: {
    facebook: [
      {
        domains: ['default'],
        appId: FACEBOOK_DEFAULT_APP_ID,
      },
    ],
    google: [
      {
        domains: ['default'],
        appId:
          '975205198704-gu24ndaopi17lkbgjk56hqceluka1qfq.apps.googleusercontent.com',
      },
    ],
    apple: {
      clientId: 'web.com.fbs.signinwithapple',
    },
  },
  supportedLanguages: [
    'ar-AE',
    'en-US',
    'es-ES',
    'pt-PT',
    'id-ID',
    'ms-MY',
    'th-TH',
    'tr-TR',
  ],
  europeLanguages: ['en-US', 'es-ES', 'pt-PT'],
  asiaAfricaLanguages: ['id-ID', 'ms-MY', 'th-TH'],
  /* Should be used as here: imgUrl = env['imgUrl'].replace('{host}', window.location.host) */
  imgUrl: `https://img.{host}/`,
  liveChatToken: 16620801,
  availableSocials: [
    'fb-msg',
    'telegram',
    'zopim',
    'viber',
    'wechat',
    'line',
    'whatsApp',
  ],
  availableSocialsForSubs: ['facebook', 'instagram', 'twitter'],
  documentPrefixesByDomain: {
    'jpfbs.com': 'japan',
    'ptfbs.com': 'portugal',
    'fbsmy.com': 'malaysia',
    'ms-brokerfbs.com': 'malaysia', // https://jira.fbs-d.com/browse/INC-464
  },
  restrictedCountries: [
    'UKR',
    'RUS',
    'USA',
    'BLZ',
    'AFG',
    'CUB',
    'ERI',
    'IRQ',
    'PRK',
    'KGZ',
    'LBY',
    'SSD',
    'SDN',
    'SYR',
    'MMR',
    'IRN',
    'SRB',
    'KAZ',
    'HND',
    'IOT',
    'VGB',
    'GIB',
    'CYM',
    'MSR',
    'SHN',
    'PCN',
    'TCA',
    'FLK',
    'SGS',
    'PSE',
    'CUW',
    'BLM',
    'GRL',
    'MYT',
    'NCL',
    'FRO',
    'IND',
    'CHN',
  ],
  islamicCountries: [
    'AFG',
    'ALB',
    'DZA',
    'AZE',
    'BHR',
    'BGD',
    'BIH',
    'BRN',
    'BFA',
    'TCD',
    'CIV',
    'DJI',
    'EGY',
    'ERI',
    'GMB',
    'GHA',
    'GIN',
    'IDN',
    'IRN',
    'IRQ',
    'JOR',
    'KAZ',
    'KWT',
    'KGZ',
    'LBN',
    'LBY',
    'MYS',
    'MDV',
    'MLI',
    'MRT',
    'MAR',
    'NGA',
    'OMN',
    'PAK',
    'PSE',
    'QAT',
    'SAU',
    'SEN',
    'SLE',
    'SOM',
    'SDN',
    'SYR',
    'TJK',
    'THA',
    'TUN',
    'TUR',
    'TKM',
    'ARE',
    'UZB',
    'YEM',
  ],
  isSwapFreeAvailable: false,
  fixRateCountries: ['IDN', 'THA', 'NGA'],
  fixRateCurrencies: ['USB', 'USF', 'USN'],
  requiredEmailConfirmationDate: new Date(2019, 1, 20),
  mobilePersonalArea: {
    onelink: {
      global:
        'https://fbs-markets-pa.onelink.me/jMwa' +
        '?pid=fbs.com' +
        '&c=From_Site_Download_Button' +
        '&af_channel=referral' +
        '&af_dp=fbspersonalarea://',

      indonesia:
        'https://fbs-markets.onelink.me/4ZdI' +
        '?pid=fbs.com' +
        '&c=From_Site_Download_Button' +
        '&af_channel=referral' +
        '&af_dp=fbspersonalarea://',

      pakistan:
        'https://fbs-markets-id.onelink.me/4U7U' +
        '?pid=fbs.com' +
        '&c=From_Site_Download_Button' +
        '&af_channel=referral' +
        '&af_dp=fbspersonalarea://',
    },
    apk: 'https://cdn.fbs.com/docs/pa-prod-release-id.apk',
    androidEnabled: true,
    iosEnabled: true,
  },
  metaTraderRestrictedCountriesList: ['PAK'],
  metaTraderLinks: {
    mac: {
      mt4: 'https://download.mql5.com/cdn/web/metaquotes.software.corp/mt4/MetaTrader4.pkg.zip',
      mt5: 'https://download.mql5.com/cdn/web/metaquotes.software.corp/mt5/MetaTrader5.pkg.zip',
    },
    windows: {
      mt4: '//download.mql5.com/cdn/web/fbs.markets.inc/mt4/fbs4setup.exe',
      mt5: '//download.mql5.com/cdn/web/fbs.markets.inc/mt5/fbs5setup.exe',
    },
    ios: {
      mt4: '//download.mql5.com/cdn/mobile/mt4/ios?server=FBS-Demo,FBSInc2-Demo,FBS-Real-1,FBS-Real-2,FBS-Real-3,FBS-Real-4,FBS-Real-5,FBS-Real-6,FBS-Real-7,FBS-Real-8,FBS-Real-9,FBS-Real-10,FBSInc-Real-11,FBS-Real-12,FBS-Real-13,FBS-Real-14,FBS-Real-15,FBSInc-Real-15,FBS-Real-16,FBSInc-Real-16,FBS-Real-17,FBSInc-Real-17,FBS-Real-18,FBSInc-Real-18,FBSInc-bonus1,FBSInc-bonus2,FBSInc-bonus3,FBSInc-bonus4',
      mt5: '//download.mql5.com/cdn/mobile/mt5/ios?server=FBS-Real,FBS-Demo',
    },
    android: {
      mt4: '//download.mql5.com/cdn/mobile/mt4/android?server=FBS-Demo,FBSInc2-Demo,FBS-Real-1,FBS-Real-2,FBS-Real-3,FBS-Real-4,FBS-Real-5,FBS-Real-6,FBS-Real-7,FBS-Real-8,FBS-Real-9,FBS-Real-10,FBSInc-Real-11,FBS-Real-12,FBS-Real-13,FBS-Real-14,FBS-Real-15,FBSInc-Real-15,FBS-Real-16,FBSInc-Real-16,FBS-Real-17,FBSInc-Real-17,FBS-Real-18,FBSInc-Real-18,FBSInc-bonus1,FBSInc-bonus2,FBSInc-bonus3,FBSInc-bonus4',
      mt5: '//download.mql5.com/cdn/mobile/mt5/android?server=FBS-Real,FBS-Demo',
    },
    androidAPKDirectLink: {
      mt4: 'https://download.mql5.com/cdn/web/metaquotes.software.corp/mt4/metatrader4.apk',
      mt5: 'https://download.mql5.com/cdn/web/metaquotes.software.corp/mt5/metatrader5.apk ',
    },
    webtrader: {
      mt4: '//fbs.com/trading/web-trader',
      mt5: '//fbs.com/trading/web-trader',
    },
    multiterminal: {
      mt4: '//download.mql5.com/cdn/web/fbs.inc/mt4/fbs4multisetup.exe',
      mt5: '',
    },
    deepLink: {
      mt4: 'metatrader4://account',
      mt5: 'metatrader5://account',
    },
  },
  growthTool: 'w6953067',
  gitlabTokenPath: './.gitlab-token',
  sentry: {
    DSN: 'https://a263125c271b4715665203be1ffee2c4@sentry.fbs.com/7',
    logger: {
      logLevel: 1,
    },
  },
  partnerAreaApkLinks: {
    'fbs.com': 'https://cdn.fbs.com/docs/fbs-com-partner-area.apk',
    'ptfbs.com': 'https://cdn.ptfbs.com/docs/ptfbs-com-partner-area.apk',
    'esfbs.com': 'https://cdn.esfbs.com/docs/esfbs-com-partner-area.apk',
    'jpfbs.com': 'https://cdn.jpfbs.com/docs/jpfbs-com-partner-area.apk',
    'fbs.co.th': 'https://cdn.fbs.co.th/docs/fbs-co-th-partner-area.apk',
    'ms-brokerfbs.com':
      'https://cdn.ms-brokerfbs.com/docs/ms-brokerfbs-com-partner-area-1.apk',
    'indofbsfx.com':
      'https://cdn.indofbsfx.com/docs/indofbsfx-com-partner-area.apk',
    'fbsfx-trading.com':
      'https://cdn.fbsfx-trading.com/docs/fbsfx-trading-com-partner-area.apk',
    'cntrade-fbs.com':
      'https://cdn.cntrade-fbs.com/docs/cntrade-fbs-com-partner-area.apk',
    'fbspaktrade.com':
      'https://cdn.fbspaktrade.com/docs/fbspaktrade-com-partner-area.apk',
    'fbstest1.com': 'https://cdn.fbs.com/docs/fbs-com-partner-area.apk',
    'fbstest2.com': 'https://cdn.fbs.com/docs/fbs-com-partner-area.apk',
  },
  partnerAreaApkFallback: 'https://cdn.fbs.com/docs/fbs-com-partner-area.apk',
  partnerPromotionStartDate: new Date(Date.UTC(2025, 2, 3)),
  partnerPromotionEndDate: new Date(Date.UTC(2025, 4, 10)),
};

const facebookSettings: { domains: string[]; appId: string }[] = [];
const domainLanguagesSettings: { domains: string[]; language: string }[] = [];

if (domainsConfig.length) {
  const domainsByLang = new Map();
  const domainsByAppId = new Map();

  domainsConfig.forEach((domain: HostDomain) => {
    if (domain.face_id) {
      const existingDomains =
        domainsByAppId.get(domain.face_id.toString()) || [];

      domainsByAppId.set(domain.face_id.toString(), [
        ...existingDomains,
        domain.domain,
      ]);
    }

    const language =
      environment.supportedLanguages.find((lang) =>
        lang.startsWith(domain.lang),
      ) || environment.defaultLanguage;
    const existingLangValue = domainsByLang.get(language) || [];

    domainsByLang.set(language, [...existingLangValue, domain.domain]);
  });

  const defaultFbIdData = domainsByAppId.get(FACEBOOK_DEFAULT_APP_ID) || [];
  domainsByAppId.set(FACEBOOK_DEFAULT_APP_ID, [...defaultFbIdData, 'default']);

  domainsByLang.forEach((value: string[], key: string) => {
    domainLanguagesSettings.push({ domains: value, language: key });
  });

  domainsByAppId.forEach((value: string[], key: string) => {
    facebookSettings.push({ domains: value, appId: key });
  });
}

environment.social.facebook = facebookSettings.length
  ? facebookSettings
  : environment.social.facebook;
environment.domainLanguages = domainLanguagesSettings.length
  ? domainLanguagesSettings
  : environment.domainLanguages;
